export const TEXT_STATE_LABEL: Record<
  number,
  { label: string; variant: "primary" | "success" | "warning" | "info" | "neutral" | "danger" }
> = {
  0: { label: "Nháp", variant: "neutral" },
  1: { label: "Đang ký", variant: "info" },
  2: { label: "Bị từ chối", variant: "danger" },
  3: { label: "Chờ ban hành", variant: "warning" },
  4: { label: "Đã ban hành", variant: "success" },
  5: { label: "Ký nháy", variant: "info" },
  6: { label: "Đã huỷ", variant: "neutral" },
  7: { label: "Nháy xong", variant: "primary" },
  27: { label: "Huỷ sau duyệt", variant: "warning" },
  [-1]: { label: "Ký song song", variant: "info" },
};

export const TEXT_PROCESS_STATE_LABEL: Record<
  number,
  { label: string; variant: "primary" | "success" | "warning" | "neutral" | "danger" }
> = {
  0: { label: "Chưa xử lý", variant: "neutral" },
  2: { label: "Từ chối", variant: "danger" },
  4: { label: "Đã ký", variant: "success" },
  5: { label: "Chờ ký nháy", variant: "warning" },
  6: { label: "Đã huỷ", variant: "neutral" },
};

export const SIGN_ROLE_LABEL: Record<number, string> = {
  336871: "Thư ký LĐ",
  336815: "Admin",
  336952: "Lãnh đạo đơn vị",
  336953: "Thường trực ĐV",
  336954: "Văn thư",
  336955: "Nhân viên",
  336991: "QL Lịch họp",
};

export function stateLabel(n: number | null) {
  if (n == null) return { label: "—", variant: "neutral" as const };
  return TEXT_STATE_LABEL[n] ?? { label: String(n), variant: "neutral" as const };
}

export function roleLabel(n: number | null) {
  if (n == null) return "—";
  return SIGN_ROLE_LABEL[n] ?? String(n);
}
